import { cn } from 'common/utils';
import React from 'react';
import { FiLink, FiList } from 'react-icons/fi';
import { TfiListOl } from 'react-icons/tfi';

const iconSize = 17;

const Toolbar = ({ editor, setLink, hasHeadings }) => {
  if (!editor) {
    return null;
  }

  const isTextSelected = !editor.state.selection.empty;
  const isBoldActive = editor.isActive('bold');
  const isItalicActive = editor.isActive('italic');
  const isUnderlineActive = editor.isActive('underline');
  const isBulletListActive = editor.isActive('bulletList');
  const isOrderedListActive = editor.isActive('orderedList');
  const isLinkActive = editor.isActive('link');
  const isHeadingActive = (level) => editor.isActive('heading', { level });
  const isHeading1Active = isHeadingActive(1);
  const isHeading2Active = isHeadingActive(2);
  const isHeading3Active = isHeadingActive(3);

  const baseBtnsClassName =
    'flex items-center justify-center w-10 h-10 rounded-md border border-gray-300 bg-white hover:bg-gray-100 transition-colors duration-200';
  const btnsActiveState = 'bg-gray-300 hover:opacity-80';

  return (
    <div className='flex items-center space-x-2 mb-2 border-b border-gray-300 pb-2'>
      {/* Heading 1 */}
      {hasHeadings && (
        <button
          type='button'
          onClick={() =>
            editor.chain().focus().toggleHeading({ level: 1 }).run()
          }
          className={cn(
            baseBtnsClassName,
            isHeading1Active ? btnsActiveState : '',
          )}
        >
          <span className='text-sm font-extrabold'>H1</span>
        </button>
      )}
      {/* Heading 2 */}
      {hasHeadings && (
        <button
          type='button'
          onClick={() =>
            editor.chain().focus().toggleHeading({ level: 2 }).run()
          }
          className={cn(
            baseBtnsClassName,
            isHeading2Active ? btnsActiveState : '',
          )}
        >
          <span className='text-sm font-bold'>H2</span>
        </button>
      )}
      {/* Heading 3 */}
      {hasHeadings && (
        <button
          type='button'
          onClick={() =>
            editor.chain().focus().toggleHeading({ level: 3 }).run()
          }
          className={cn(
            baseBtnsClassName,
            isHeading3Active ? btnsActiveState : '',
          )}
        >
          <span className='text-sm font-semibold'>H3</span>
        </button>
      )}
      {/* Bold Button */}
      <button
        type='button'
        onClick={() => editor.chain().focus().toggleBold().run()}
        disabled={!editor.can().chain().focus().toggleBold().run()}
        className={cn(baseBtnsClassName, isBoldActive ? btnsActiveState : '')}
      >
        <strong className={`text-[${iconSize}px]`}>B</strong>
      </button>
      {/* Italic Button */}
      <button
        type='button'
        onClick={() => editor.chain().focus().toggleItalic().run()}
        disabled={!editor.can().chain().focus().toggleItalic().run()}
        className={cn(baseBtnsClassName, isItalicActive ? btnsActiveState : '')}
      >
        <em className={`text-[${iconSize}px]`}>I</em>
      </button>
      {/* Underline Button */}
      <button
        type='button'
        onClick={() => editor.chain().focus().toggleUnderline().run()}
        disabled={!editor.can().chain().focus().toggleUnderline().run()}
        className={cn(
          baseBtnsClassName,
          isUnderlineActive ? btnsActiveState : '',
        )}
      >
        <u className={`text-[${iconSize}px]`}>U</u>
      </button>
      {/* Bullet List Button */}
      <button
        type='button'
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        className={cn(
          baseBtnsClassName,
          isBulletListActive ? btnsActiveState : '',
        )}
      >
        <FiList className={`text-[${iconSize}px]`} />
      </button>
      {/* Ordered List Button */}
      <button
        type='button'
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        className={cn(
          baseBtnsClassName,
          isOrderedListActive ? btnsActiveState : '',
        )}
      >
        <TfiListOl className={`text-[${iconSize}px]`} />
      </button>
      {/* Link Button */}
      <button
        type='button'
        onClick={setLink}
        disabled={!isTextSelected}
        className={cn(
          baseBtnsClassName,
          isLinkActive && isTextSelected ? btnsActiveState : '',
          !isTextSelected && 'opacity-50 cursor-not-allowed hover:bg-white',
        )}
      >
        <FiLink className={`text-[${iconSize}px]`} />
      </button>
    </div>
  );
};

export default Toolbar;
